<template>
    <div class="calendar-type jumbotron d-flex align-items-center" :style="`background: ${calendarType.bgColor};`">
        <div class="calendar-type-info flex-grow-1">
            <span>{{ calendarType.name }}</span>
        </div>

        <div class="calendar-type-actions">
            <b-button
                type="button"
                variant="outline-danger"
                v-b-tooltip.hover
                title="Type verwijderen"
                @click="doDelete"
            >
                <fa-icon v-if="!isDeleting" icon="trash" />
                <loader-spinner v-else iscolor="#F0F0F0" :show-spinner="true" />
            </b-button>

            <b-button
                class="ml-1"
                type="button"
                variant="outline-primary"
                v-b-tooltip.hover
                title="Type verwijderen"
                @click="$emit('edit', calendarType.id)"
            >
                <fa-icon icon="edit" />
            </b-button>
        </div>
    </div>
</template>

<script>
import LoaderSpinner from '../../elements/LoaderSpinner';
import { mapActions } from 'vuex';

export default {
    components: {
        LoaderSpinner
    },
    props: {
        calendarType: {
            type: Object,
        }
    },
    data: () => ({
        isDeleting: false,
    }),
    computed: {},
    methods: {
        ...mapActions([
            'deleteType'
        ]),

        async doDelete() {
            this.isDeleting = true;

            try {
                await this.deleteType(this.calendarType.id);

                this.isDeleting = false;

                this.$emit('deleted')
            }
            catch (error) {
                console.log(error);

                this.isDeleting = false;
            }
        }
    },
    mounted () {}
}
</script>

<style lang="scss">
.calendar-type {
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem !important;

    &-actions {
        margin: -0.375rem -0.75rem;
        padding: 0.375rem 0.75rem;
        background: white;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
        border: 1px solid rgba(#000, 0.15);
    }

    &-info {
        font-size: 1.125rem;
        color: #FCFCFC;
        text-transform: capitalize;
        
    }
}
</style>


// WEBPACK FOOTER //
// CalendarType.vue?0df2c6a8